export function regexIgnoreAccent(term: string): RegExp {
  const accentMap = {
    a: '[aàáâãäå]',
    e: '[eèéêë]',
    i: '[iìíîï]',
    o: '[oòóôõö]',
    u: '[uùúûü]',
    c: '[cç]',
    n: '[nñ]',
  };

  // Normalize the search term by removing accents and converting to lowercase
  let regexPattern = term
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  Object.keys(accentMap).forEach((letter) => {
    regexPattern = regexPattern.replace(new RegExp(letter, 'g'), accentMap[letter]);
  });

  return new RegExp(regexPattern, 'i');
}
